exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".col-auto[data-v-36b1d5df]{padding-left:0}[data-v-36b1d5df] .modal-content{border:1px solid #ccc;border-radius:5px;top:10px}[data-v-36b1d5df] .modal-header{padding:5px;padding-left:12px;height:33px}[data-v-36b1d5df] .modal-footer{padding:6px}\n", ""]);

